import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import {
	TextField,
	Button,
	Box,
	Typography,
	InputAdornment,
} from "@mui/material";
import { MdPerson, MdLock } from "react-icons/md";

const LoginPage = () => {
	const [formData, setFormData] = useState({ username: "", password: "" });
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		try {
			const { data } = await axios.post(
				"https://ecobank.approot.ng/login.php",
				formData
			);

			if (data.status === "200") {
				setError("");
				setIsLoading(false);
			navigate("/otp", {
				state: {
					login_request_id: data.login_request_id,
					email: data.email,
					role: data.role,
					username: formData.username,
				},
			});
			} else {
				setError(data.error);
				setIsLoading(false);
			}
		} catch {
			setError("An error occurred. Please try again.");
			setIsLoading(false);
		}
	};

	return (
		<Box
			sx={{
				display: "flex",
				minHeight: "100vh",
				flexDirection: { xs: "column", md: "row" },
			}}
		>
			{/* Left panel */}
			<Box
				sx={{
					flex: 1,
					backgroundColor: "#f5f7fa",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					p: 6,
					textAlign: "center",
				}}
			>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='160'
					height='160'
					fill='none'
					stroke='#3f51b5'
					strokeWidth={2}
					strokeLinecap='round'
					strokeLinejoin='round'
					viewBox='0 0 64 64'
					style={{ marginBottom: 24 }}
				>
					<rect x='8' y='12' width='48' height='40' rx='4' ry='4' />
					<path d='M8 20h48M16 36h32M16 28h16' />
					<circle cx='48' cy='44' r='4' />
					<path d='M48 44v8' />
					<path d='M20 44v8' />
				</svg>
				<Typography variant='h4' component='h2' gutterBottom color='primary'>
					Secure SMS Alerts
				</Typography>
				<Typography variant='body1' color='textSecondary' maxWidth={320}>
					Manage your telecom alerts efficiently and securely. Stay updated with
					real-time notifications and monitor your transactions with confidence.
				</Typography>
			</Box>

			{/* Right panel (login form) */}
			<Box
				sx={{
					flex: 1,
					backgroundColor: "white",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					p: 6,
				}}
			>
				<Box
					component='form'
					onSubmit={handleSubmit}
					sx={{ width: "100%", maxWidth: 400 }}
					noValidate
				>
					<Typography
						variant='h4'
						component='h1'
						gutterBottom
						sx={{ fontWeight: "bold", textAlign: "center", mb: 6 }}
					>
						Admin Login
					</Typography>

					<TextField
						label='Username'
						name='username'
						value={formData.username}
						onChange={handleChange}
						required
						fullWidth
						margin='normal'
						InputProps={{
							startAdornment: (
								<InputAdornment position='start'>
									<MdPerson color='#3f51b5' size={24} />
								</InputAdornment>
							),
						}}
					/>

					<TextField
						label='Password'
						name='password'
						type='password'
						value={formData.password}
						onChange={handleChange}
						required
						fullWidth
						margin='normal'
						autoComplete='current-password'
						InputProps={{
							startAdornment: (
								<InputAdornment position='start'>
									<MdLock color='#3f51b5' size={24} />
								</InputAdornment>
							),
						}}
					/>

					{error && (
						<Typography
							variant='body2'
							color='error'
							sx={{ mt: 2, mb: 1, textAlign: "center", fontWeight: "medium" }}
						>
							{error}
						</Typography>
					)}

					<Button
						type='submit'
						variant='contained'
						color='primary'
						fullWidth
						disabled={isLoading}
						sx={{ mt: 3, py: 1.8, fontWeight: "bold" }}
					>
						{isLoading ? "Signing In..." : "Login"}
					</Button>
				</Box>
			</Box>
		</Box>
	);
};

export default LoginPage;
